export default __webpack_public_path__ + "static/media/powered-by-white.7ee72132.png";